import type { ModalRequiredProps } from '../../../../components/Toolkit/Modal/BaseModal';
import type { GTM_PAGES, IUpsellsData } from '../../../../types';

export enum BOOST_MODAL_GTM_EVENT {
  BOOST_MODAL_OPEN = 'boost_modal_open',
  BOOST_MODAL_CLOSED = 'boost_modal_closed',
}

export enum UPSELL_TYPES {
  BUMP = 'BUMP',
  SUPERBOOSTER = 'SUPERBOOSTER',
  SPOTLIGHT = 'SPOTLIGHT',
}

interface IBaseBoost extends ModalRequiredProps {
  baseUrl: string;
  adId?: number;
  displaySuggestedProductModal?: boolean;
  bumpEligible?: boolean;
  spotlightEligible?: boolean;
  section?: string;
  handleSelect?: (bundleID?: number) => void;
  pageType?: GTM_PAGES.AD_DETAILS | GTM_PAGES.DASHBOARD_MY_ADS;
}

export interface BoostModalProps extends IBaseBoost {
  boostInfoList: (IUpsellsData | undefined)[];
  cdnUrl?: string;
}

export interface IUseBoostModal extends IBaseBoost {
  userId?: number;
}
